import React from 'react';
import { OrderBookRowFieldProps } from '../../../types';

export const OrderBookSidePlaceholder = (props: OrderBookRowFieldProps) => {
  return null;
};

export default OrderBookSidePlaceholder;
